<template>
  <v-container grid-list-md fluid class="pa-0">
    <!--<v-card class="pa-2 card-r mb-2">-->
      <v-toolbar class="mb-2 tow-clor-1 card-r shadow-1 pl-3 text-white">
        <div class="text-xs-left f-17">Subscription</div>
      </v-toolbar>
    <!--</v-card>-->
    <!--<v-card class="pa-2 card-r mb-2 grey lighten-4">-->
    <v-data-table :headers="headers" :items="SubscriptionData" class=" card-r no-shadow laptop-data-table">
                    <template slot="items" slot-scope="props">
                        <td>{{ props.item.name }}</td>
                        <td>{{ props.item.start_date }}</td>
                        <td>{{ props.item.endDate }}</td>
                        <td>{{ props.item.cost }}</td>
                        <td>{{ props.item.dkk }}</td>
                        <td>
                          <v-btn flat class="ma-0" icon>
                            <v-icon @click="dialog =true">visibility</v-icon>
                          </v-btn>
                        </td>
                      <v-dialog
                        v-model="dialog"
                        width="500">
                        <v-card class="pa-2 card-r mb-2 grey lighten-4">
                          <v-toolbar class="tow-clor-1 card-r shadow-1 pl-3 text-white">
                            <div class="text-xs-left f-20 text-capitalize">Invoice</div>
                            <v-spacer></v-spacer>
                            <v-btn class="mr-2 tow-clor-1" icon @click="dialog = false">
                              <v-icon class="text-white f-28">close</v-icon>
                            </v-btn>
                          </v-toolbar>
                          <v-layout row wrap class="pa-0">
                            <v-flex d-flex lg12 sm12 xs12>
                              <v-card class="PersonalCards w-100 mt-2 pa-0  shadow-1 card-r">
                                <v-layout wrap xs12 class="pa-1" >
                                  <v-flex  xs12 class="text-xs-center">
                                    <v-avatar class="objec-fit" size="100">
                                      <img class="br-2" src="https://wallpaperaccess.com/full/128916.jpg" alt="logo">
                                    </v-avatar>
                                  </v-flex>
                                  <v-flex xs12 class="pa-0">
                                    <!--<v-card class="PersonalCards w-100 mt-2 pa-0  shadow-1 card-r">-->
                                    <v-layout row class="ma-0">
                                      <v-flex xs4 class="label pa-0 f-13 font-weight-regular"><p>Customer Name:-</p> </v-flex>
                                      <v-flex xs8 class="scroll-y text-xs-right word-break pa-0 f-13 font-weight-regular">
                                        <strong>{{userData.name}} </strong><br>
                                        {{userData.street}} {{userData.streetNumber}} {{userData.floor}}
                                        {{userData.door}} {{userData.zipCode}} {{userData.city}}
                                      </v-flex>
                                    </v-layout>
                                    <!--</v-card>-->
                                  </v-flex>
                                  <v-flex xs12 class="pa-0">
                                    <!--<v-card class="PersonalCards w-100 mt-2 pa-0  shadow-1 card-r">-->
                                    <v-layout row class="ma-0">
                                      <v-flex xs4 class="label pa-0 f-13 font-weight-regular"><p>Customer Name:-</p> </v-flex>
                                      <v-flex xs8 class="scroll-y text-xs-right word-break pa-0 f-13 font-weight-regular">{{userData.name}}</v-flex>
                                    </v-layout>
                                    <!--</v-card>-->
                                  </v-flex>
                                  <v-flex xs12 class="pa-0">
                                    <!--<v-card class="PersonalCards w-100 mt-2 pa-0  shadow-1 card-r">-->
                                    <v-layout row class="ma-0">
                                      <v-flex xs4 class="label pa-0 f-13 font-weight-regular"><p>Subscription Number: </p> </v-flex>
                                      <v-flex xs8 class="scroll-y text-xs-right word-break pa-0 f-13 font-weight-regular"> {{ props.item.subscription_id }}</v-flex>
                                    </v-layout>
                                    <!--</v-card>-->
                                  </v-flex>
                                  <v-flex xs12 class="pa-0">
                                    <!--<v-card class="PersonalCards w-100 mt-2 pa-0  shadow-1 card-r">-->
                                    <v-layout row class="ma-0">
                                      <v-flex xs4 class="label pa-0 f-13 font-weight-regular"><p>Validity Period:</p> </v-flex>
                                      <v-flex xs8 class="scroll-y text-xs-right word-break pa-0 f-13 font-weight-regular">
                                        <span class="font-weight-bold">{{ props.item.start_date }}</span>
                                        to <span class="font-weight-bold">{{ props.item.endDate }}</span></v-flex>
                                    </v-layout>
                                    <!--</v-card>-->
                                  </v-flex>
                                  <v-flex xs12 class="pa-0">
                                    <!--<v-card class="PersonalCards w-100 mt-2 pa-0  shadow-1 card-r">-->
                                    <v-layout row class="ma-0">
                                      <v-flex xs4 class="label pa-0 f-13 font-weight-regular"><p>Amount Paid</p> </v-flex>
                                      <v-flex xs8 class="scroll-y text-xs-right word-break pa-0 f-13 font-weight-regular">DKK {{ props.item.cost }}</v-flex>
                                    </v-layout>
                                    <!--</v-card>-->
                                  </v-flex>

                                </v-layout>
                              </v-card>
                            </v-flex>
                          </v-layout>
                        </v-card>
                      </v-dialog>

                    </template>
                </v-data-table>
    <!--</v-card>-->
     <v-layout>
            <v-flex>

                <v-data-table :items="SubscriptionData" class=" card-r no-shadow mobile-data-table">
                    <template slot="items" slot-scope="props">
                      <v-card class="mb-3 grey lighten-3 pa-3 pt-4 no-shadow card-r">
                        <v-flex><span class="font-weight-bold mr-1">Name: </span>{{ props.item.name }}</v-flex>
                        <v-flex><span class="font-weight-bold mr-1">Start Date: </span>{{ props.item.start_date }}</v-flex>
                        <v-flex><span class="font-weight-bold mr-1">End Date: </span>{{ props.item.endDate }}</v-flex>
                        <v-flex><span class="font-weight-bold mr-1">Cost: </span>{{ props.item.cost }}</v-flex>
                        <v-flex><span class="font-weight-bold mr-1">DKK: </span>{{ props.item.dkk }}</v-flex>
                            <v-dialog
                            v-model="dialogg"
                            width="500">
                            <v-icon class="font-weight-bold" slot="activator">visibility</v-icon>
                              <v-card class="pa-2 card-r grey lighten-4">
                                <v-toolbar class="tow-clor-1 card-r shadow-1 pl-3 text-white">
                                  <div class="text-xs-left f-20 text-capitalize">Invoice</div>
                                  <v-spacer></v-spacer>
                                  <v-btn class="mr-2 tow-clor-1" icon @click="dialogg = false">
                                    <v-icon class="text-white f-28">close</v-icon>
                                  </v-btn>
                                </v-toolbar>
                                <v-layout row wrap class="pa-0">
                                  <v-flex d-flex lg12 sm12 xs12>
                                    <v-card class="PersonalCards w-100 mt-2 pa-0  shadow-1 card-r">
                                      <v-layout wrap xs12 class="pa-1" >
                                        <v-flex  xs12 class="text-xs-center">
                                          <v-avatar class="objec-fit" size="100">
                                            <img class="br-2" src="https://wallpaperaccess.com/full/128916.jpg" alt="logo">
                                          </v-avatar>
                                        </v-flex>
                                        <v-flex xs12 class="pa-0">
                                          <!--<v-card class="PersonalCards w-100 mt-2 pa-0  shadow-1 card-r">-->
                                          <v-layout row class="ma-0">
                                            <v-flex xs4 class="label pa-0 f-13 font-weight-regular"><p>Customer Name:-</p> </v-flex>
                                            <v-flex xs8 class="scroll-y text-xs-right word-break pa-0 f-13 font-weight-regular">
                                              <strong>{{userData.name}} </strong><br>
                                              {{userData.street}} {{userData.streetNumber}} {{userData.floor}}
                                              {{userData.door}} {{userData.zipCode}} {{userData.city}}
                                            </v-flex>
                                          </v-layout>
                                          <!--</v-card>-->
                                        </v-flex>
                                        <v-flex xs12 class="pa-0">
                                          <!--<v-card class="PersonalCards w-100 mt-2 pa-0  shadow-1 card-r">-->
                                          <v-layout row class="ma-0">
                                            <v-flex xs4 class="label pa-0 f-13 font-weight-regular"><p>Customer Name:-</p> </v-flex>
                                            <v-flex xs8 class="scroll-y text-xs-right word-break pa-0 f-13 font-weight-regular">{{userData.name}}</v-flex>
                                          </v-layout>
                                          <!--</v-card>-->
                                        </v-flex>
                                        <v-flex xs12 class="pa-0">
                                          <!--<v-card class="PersonalCards w-100 mt-2 pa-0  shadow-1 card-r">-->
                                          <v-layout row class="ma-0">
                                            <v-flex xs4 class="label pa-0 f-13 font-weight-regular"><p>Subscription Number: </p> </v-flex>
                                            <v-flex xs8 class="scroll-y text-xs-right word-break pa-0 f-13 font-weight-regular"> {{ props.item.subscription_id }}</v-flex>
                                          </v-layout>
                                          <!--</v-card>-->
                                        </v-flex>
                                        <v-flex xs12 class="pa-0">
                                          <!--<v-card class="PersonalCards w-100 mt-2 pa-0  shadow-1 card-r">-->
                                          <v-layout row class="ma-0">
                                            <v-flex xs4 class="label pa-0 f-13 font-weight-regular"><p>Validity Period:</p> </v-flex>
                                            <v-flex xs8 class="scroll-y text-xs-right word-break pa-0 f-13 font-weight-regular">
                                              <span class="font-weight-bold">{{ props.item.start_date }}</span>
                                              to <span class="font-weight-bold">{{ props.item.endDate }}</span></v-flex>
                                          </v-layout>
                                          <!--</v-card>-->
                                        </v-flex>
                                        <v-flex xs12 class="pa-0">
                                          <!--<v-card class="PersonalCards w-100 mt-2 pa-0  shadow-1 card-r">-->
                                          <v-layout row class="ma-0">
                                            <v-flex xs4 class="label pa-0 f-13 font-weight-regular"><p>Amount Paid</p> </v-flex>
                                            <v-flex xs8 class="scroll-y text-xs-right word-break pa-0 f-13 font-weight-regular">DKK {{ props.item.cost }}</v-flex>
                                          </v-layout>
                                          <!--</v-card>-->
                                        </v-flex>

                                      </v-layout>
                                    </v-card>
                                  </v-flex>
                                </v-layout>
                              </v-card>
                          </v-dialog>
                          </v-card>

                    </template>
                </v-data-table>
            </v-flex>

        </v-layout>
    </v-container>
</template>
<script>
/* eslint-disable */
export default {
  name:"Subscription",
  data:()=>({
    dialog:false,
    dialogg:false,
    userData:'',
    headers: [
        { text: "Name", value: "name" },
        {text: "Start Date",value: "start_date"},
        { text: "End Date", value: "endDate" },
        { text: "Amount", value: "cost" },
        { text: "DKK", value: "dkk" },
        { text: "Actions", value: "Actions" },
    ],
    SubscriptionData:[]
  }),
  created(){
    Store.dispatch("AdminProfile/getSubscriptionInformation")
    var SubscriptionData=Store.state.AdminProfile.Subscription
    for(var x=0;x<SubscriptionData.length;x++){
      var temp={
           start_date:SubscriptionData[x].start_date,
           endDate:SubscriptionData[x].expiry_date,
           cost:SubscriptionData[x].amount,
           name:SubscriptionData[x].admin_package_name,
           dkk:"dkk",
           subscription_id:SubscriptionData[x].subscription_id,
         }
         this.SubscriptionData.push(temp)
    }
      // this.SubscriptionData=Store.state.AdminProfile.Subscription
  this.userData=Store.state.user
  }
}
</script>
<style>
  .invoice{
    width: 700px;

  }
  .invoice-logo{
    margin: auto;
    border: 3px solid white;
    width: 150px !important;
    height: 150px;
    border-radius: 50%;
    -webkit-box-shadow: 10px 10px 14px -2px rgba(173,173,173,1);
    -moz-box-shadow: 10px 10px 14px -2px rgba(173,173,173,1);
    box-shadow: 10px 10px 14px -2px rgba(173,173,173,1);
    background-color: transparent !important;
  }
  .layout-invoice-contant{
    font-size: 12px;
    font-weight: 600;
  }
  .layout-invoice-contant span{
    padding: 10px 0px 10px 0px;

  }
  .layout-invoice-contant .span{
    border: 1px solid #0097cf;
    padding-left: 25px;
    padding-right: 25px;

  }
  .invoice .v-dialog:not(.v-dialog--fullscreen){
    overflow: hidden;
  }

/*
      ##Device = Desktops
      ##Screen = 1281px to higher resolution desktops
    */

    @media (min-width: 1281px) {
          .mobile-data-table{
              display: none
          }
          .laptop-data-table{
              display: block
          }
    }

    /*
      ##Device = Laptops, Desktops
      ##Screen = B/w 1025px to 1280px
    */

    @media (min-width: 1025px) and (max-width: 1280px) {
          .mobile-data-table{
              display: none
          }
          .laptop-data-table{
              display: block
          }
    }

    /*
      ##Device = Tablets, Ipads (portrait)
      ##Screen = B/w 768px to 1024px
    */

    @media (min-width: 768px) and (max-width: 1024px) {
          .mobile-data-table{
              display: none
          }
          .laptop-data-table{
              display: block
          }
    }

    /*
      ##Device = Tablets, Ipads (landscape)
      ##Screen = B/w 768px to 1024px
    */

    @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
          .mobile-data-table{
              display: none
          }
          .laptop-data-table{
              display: block
          }
    }

    /*
      ##Device = Low Resolution Tablets, Mobiles (Landscape)
      ##Screen = B/w 481px to 767px
    */

    @media (min-width: 481px) and (max-width: 767px) {
          .mobile-data-table{
              display: block
          }
          .laptop-data-table{
              display: none
          }
    }

    /*
      ##Device = Most of the Smartphones Mobiles (Portrait)
      ##Screen = B/w 320px to 479px
    */

    @media (min-width: 320px) and (max-width: 480px) {
          .mobile-data-table{
              display: block
          }
          .laptop-data-table{
              display: none
          }
    }
</style>



// WEBPACK FOOTER //
// src/components/profile/admin/Subscription.vue